export default __webpack_public_path__ + "static/media/noImage.08ba4a39.jpg";